module.exports = __webpack_public_path__ + "2020celebration/img/p3.f805ca8c.png";